import promptBox, { PROMPTBOX_TYPE_OK } from "./promptBox";

const showAsyncInner = (isHtml) => (title, message) => {
    const dialog = promptBox({
        title,
        text: message,
        textIsHtml: isHtml,
        type: PROMPTBOX_TYPE_OK,
    });

    return dialog.showAsync();
}

export const showMessageBox = showAsyncInner(false);
export const showHtmlMessageBox = showAsyncInner(true);
